import { useState, useEffect } from 'react';
import { ModalComponent } from '../../../components/Modal/ModalComponent/ModalComponent';
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import { useResponseHandler } from '../../../common/auth';
import { OrderCollectCard } from './OrderCollectCard/OrderCollectCard';
import './ModalCollectOrders.scss';

const ModalCollectOrders = ({ checkedItems, setIsModal, status }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();

    const [postingResults, setPostingResults] = useState([]);
    const [loading, setLoading] = useState(true);

    const postings = checkedItems?.map((item) => ({
        api_id: item?.api_id,
        mp_id: item?.mp_id,
        posting_number: item?.['Номер отправления'],
        offer_id: item?.offer_id
    }));

    // Получение товаров и статусов
    const fetchGetStatus = () => {
        setLoading(true);
        const url = 'https://apps0.ecomru.ru:4449/v1/orders/packaging';

        fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({ postings }),
        })
            .then(handleTableResponse)
            .then((json) => {
                const results = Array.isArray(json) ? json : json?.postings ?? json?.data ?? [];
                setPostingResults(results);
            })
            .catch(handleRequestError)
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchGetStatus();
    }, []);

    const handleSubmit = ({ api_id, mp_id, offer_id, posting_number, products }) => {
        const url = 'https://apps0.ecomru.ru:4449/v1/orders/packaging/ship';
        fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                api_id,
                mp_id,
                offer_id,
                posting_number,
                packages: {
                   products: products 
                } 
            }),
        })
            .then(handleTableResponse)
            .then((json) => console.log('Заказ собран:', json))
            .catch(handleRequestError);
    };

    return (
        <ModalComponent
            title='Собрать заказы'
            onClose={(e) => setIsModal(false)}
            loading={loading}
            style={{ maxWidth: '800px' }}
            isNoData={!postingResults.length}
            descriptionNoData='Не удалось получить информацию по отправлениям.'
            child={
                <div className='modal-сollect-orders__content'>
                    {!loading && postingResults.length > 0 &&
                        <div className='modal-сollect-orders__cards'>
                            {postingResults.map((posting, idx) => (
                                <OrderCollectCard
                                    key={posting.posting_number ?? idx}
                                    posting={posting}
                                    onSubmit={handleSubmit}
                                />
                            ))}
                        </div>
                    }
                </div>
            }
        />
    );
};

export { ModalCollectOrders };
